<div class="modal-header" id="material-pricing-modal-title">
    <h3 class="modal-title">{{ strings.header }}</h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>
<div class="modal-body">
    <form [formGroup]="materialPricingForm">
        <fieldset formArrayName="formChildren" [disabled]="isLoading">
            <div class="container-fluid">
                <div class="row mb-3 form-container">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="materialNo"
                        translate="MATERIAL_CUSTOMER_PRICING_LABEL_MATERIAL_NUMBER"
                    ></label>
                    <div class="col-12 col-lg-3">
                        <pace-core-text-input
                            id="materialNo"
                            name="materialNo"
                            [(model)]="model.materialNumber"
                            [parentForm]="materialPricingFormChildren"
                        ></pace-core-text-input>
                    </div>
                    <label
                        class="col-12 col-lg-1 col-form-label text-start text-lg-end"
                        for="quantity"
                        translate="MATERIAL_CUSTOMER_PRICING_LABEL_QUANTITY"
                    ></label>
                    <div class="col-12 col-lg-3">
                        <pace-core-number-stepper
                            [(model)]="model.quantity"
                            name="quantity"
                            id="quantity"
                            [parentForm]="materialPricingFormChildren"
                        ></pace-core-number-stepper>
                    </div>
                    <div class="col-2 mt-2 mt-lg-0">
                        @let disableAddMaterial = (enableAddMaterial$ | async) === false;
                        <button
                            class="btn btn-primary float-lg-end"
                            (click)="addMaterial()"
                            translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_ADD"
                            [disabled]="this.materialPricingForm.invalid || disableAddMaterial"
                        >
                            @if (disableAddMaterial) {
                                <fa-icon [icon]="faBan" class="ms-1 orange"></fa-icon>
                            }
                        </button>
                    </div>
                </div>

                <div class="col-12">
                    <div class="row table-header fw-bold py-2">
                        <div class="col-1"></div>
                        <div class="col-3 col-sm-2">
                            <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_MATERIAL"></span>
                        </div>
                        <div class="col-2">
                            <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_STORAGE_LOCATION"></span>
                        </div>
                        <div class="col-2">
                            <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_AVAILABLE"></span>
                        </div>
                        <div class="col-3">
                            @if (displayCustomerPrice) {
                                <div translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_PRICE"></div>
                            }
                            @if (displayRepairPrice) {
                                <div translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_REPAIR_PRICE"></div>
                            }
                        </div>
                    </div>
                </div>

                @for (material of model.partSet.value; track material; let i = $index) {
                    <div class="table-row">
                        <pace-material-pricing-details-expandable
                            [material]="material"
                            [index]="i"
                            [displayRepairPrice]="displayRepairPrice"
                            [displayCustomerPrice]="displayCustomerPrice"
                            (materialDeletedEvent)="deleteMaterial($event)"
                        ></pace-material-pricing-details-expandable>
                    </div>
                }
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    @if (isLoading) {
        <progressbar [value]="100">Loading...</progressbar>
    }
    @if (!isLoading) {
        @if (model.sparePartsCatalogLink) {
            <div class="me-lg-auto flex-grow-1 flex-lg-grow-0 d-lg-block d-none" paceCoreLink>
                <a
                    class="btn btn-primary pace-link w-100"
                    href="{{ model.sparePartsCatalogLink }}"
                    target="_blank"
                    translate="SPARE_PARTS_CATALOG_LINK_LABEL"
                ></a>
            </div>
        }
        <div class="d-lg-block d-none">
            @if (!enableMatOrderCheckOnlineOnly) {
                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="model.partSet.value.length === 0"
                    (click)="checkMaterialPricing()"
                    translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CHECK"
                ></button>
            }
            <button
                type="button"
                class="btn btn-primary mx-2"
                [disabled]="model.partSet.value.length === 0 || model.isMaterialRequested"
                (click)="order()"
                translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_REQUEST"
            ></button>
            @if (displayMaterialQuote) {
                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="model.partSet.value.length === 0"
                    (click)="createQuote()"
                    translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CREATE_QUOTE"
                ></button>
            }
        </div>
        <!-- Main Action button for mobile view -->
        <div class="d-lg-none d-block flex-grow-1">
            @if (displaySparePartsLinkAsMainActionButton) {
                <a
                    class="btn btn-primary btn-lg pace-link w-100"
                    href="{{ model.sparePartsCatalogLink }}"
                    target="_blank"
                    translate="SPARE_PARTS_CATALOG_LINK_LABEL"
                ></a>
            }
            @if (displayCheckAsMainActionButton) {
                <button
                    type="button"
                    class="btn btn-primary btn-lg w-100"
                    [disabled]="model.partSet.value.length === 0"
                    (click)="checkMaterialPricing()"
                    translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CHECK"
                ></button>
            }
            @if (displayRequestAsMainActionButton) {
                <button
                    type="button"
                    class="btn btn-primary btn-lg w-100"
                    [disabled]="model.partSet.value.length === 0 || model.isMaterialRequested"
                    (click)="order()"
                    translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_REQUEST"
                ></button>
            }
        </div>
        <div class="btn-group d-lg-none menu-container" dropdown [dropup]="true">
            <button
                id="button-toggler"
                dropdownToggle
                type="button"
                class="btn btn-secondary btn-lg more-toggler"
                aria-controls="dropdown-toggler"
                [attr.aria-label]="'MATERIALMATERIAL_CUSTOMER_PRICING_ARIA_LABEL' | translate"
            >
                <fa-icon [icon]="faEllipsisV"></fa-icon>
            </button>
            <ul
                id="dropdown-toggler"
                *dropdownMenu
                class="dropdown-menu dropdown-menu-right w-100"
                role="menu"
                aria-labelledby="button-toggler"
                [attr.aria-label]="'MATERIALMATERIAL_CUSTOMER_PRICING_ARIA_LABEL' | translate"
            >
                @if (!displaySparePartsLinkAsMainActionButton) {
                    <li role="menuitem">
                        @if (model.sparePartsCatalogLink) {
                            <button type="button" class="btn btn-secondary btn-lg w-100 border-0" paceCoreLink>
                                <a
                                    href="{{ model.sparePartsCatalogLink }}"
                                    target="_blank"
                                    translate="SPARE_PARTS_CATALOG_LINK_LABEL"
                                ></a>
                            </button>
                        }
                    </li>
                }
                <li role="menuitem">
                    @if (!displayCheckAsMainActionButton && !enableMatOrderCheckOnlineOnly) {
                        <button
                            type="button"
                            class="btn btn-secondary btn-lg w-100"
                            [disabled]="model.partSet.value.length === 0"
                            (click)="checkMaterialPricing()"
                            translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CHECK"
                        ></button>
                    }
                </li>
                <li role="menuitem">
                    @if (!displayRequestAsMainActionButton) {
                        <button
                            type="button"
                            class="btn btn-secondary btn-lg w-100 border-0"
                            [disabled]="model.partSet.value.length === 0 || model.isMaterialRequested"
                            (click)="order()"
                            translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_REQUEST"
                        ></button>
                    }
                </li>
                <li role="menuitem">
                    @if (displayMaterialQuote) {
                        <button
                            type="button"
                            class="btn btn-secondary btn-lg w-100 border-0"
                            [disabled]="model.partSet.value.length === 0"
                            (click)="createQuote()"
                            translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CREATE_QUOTE"
                        ></button>
                    }
                </li>
            </ul>
        </div>
    }
</div>
